<div class="p500-ui-modal__inner">
  <div class="p500-ui-modal__head">
    <div class="p500-ui-modal__close" (click)="close(); $event.preventDefault()">
      <p500-ui-icon name="close" size="20px"></p500-ui-icon>
    </div>
    <div class="p500-ui-modal__title c-modal__title" i18n="@@drilldown.additional_details">Additional {{ data.label }} details</div>
    <div class="p500-ui-modal__subtitle" i18n="@@drilldown.additional_details_description">
      Add additional data to the report about {{ data.label }}
    </div>
  </div>
  <div class="p500-ui-modal__body">
    <div class="c-form c-form--d">
      <ng-container *ngFor="let item of data.relations">
        <div class="row">
          <div class="c-form__section col-12">
            <gtd-group-checkbox [formControl]="form.get(item.key).get('values')" [data]="item.fields" [label]="item.label" />
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="filterMap.size">
        <ng-container *ngFor="let item of data.relations; index as i">
          <ng-container *ngFor="let filterCtr of form.get(item.key).get('filters').controls | keyvalue; index as j">
            <ng-container *ngIf="i === 0 && j === 0">
              <div class="c-modal__body-title">
                <div class="title" i18n="@@common.filters">Filters</div>
              </div>
            </ng-container>
            <div class="row" *ngIf="form.get(item.key).get('values').value?.length">
              <div class="c-form__section col-12">
                <p500-ui-select-field
                  [formControl]="filterCtr.value"
                  [multiple]="true"
                  [clearable]="true"
                  [label]="filterMap.get(filterCtr.key).label"
                  [data]="filterMap.get(filterCtr.key).values"
                >
                </p500-ui-select-field>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div class="c-modal__footer justify-content-between">
    <button type="button" p500-ui-button stroked="true" i18n="@@common.reset" (click)="reset(); close()">Reset</button>
    <div class="d-flex">
      <div class="c-modal__action" (click)="close(); $event.preventDefault()">
        <button type="button" p500-ui-button stroked="true" i18n="@@common.cancel">Cancel</button>
      </div>
      <div class="c-modal__action">
        <button
          type="button"
          p500-ui-button
          classIcon="p500-ui-icon-check"
          positionIcon="right"
          i18n="@@common.apply"
          (click)="submit(); close()"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</div>
